<template>
	<div v-if="rakuten_name=='chatgpt001'">
		ChatGpt
	</div>
	<div v-else-if="rakuten_name=='rakuten_01'">
		乐天数据接口
	</div>
	<div v-else class="cs-p">
		<div class="cs-card">
			<i class="el-icon-data-line cs-pb">
				<span class="cs-p-5">订单状态</span>
				<!-- <span class="cs-card-sub">统计日期：{{updateTime}}</span> -->
			</i>
			<i class="el-icon-refresh cs-card-sub cs-fr link">
				<span class="cs-pl-5" @click="handleRefresh">刷新</span>
			</i>

			<div flex="cross:center main:center">
				<div v-for="(item, key) in orderStatus" :key="key" flex-box="1" style="cursor: pointer;" @click="this.$router.push('/main/order_list')">
					<div class="cs-order cs-tc link" @click="handleOpen('order-admin-list')">
						<!-- <cs-count-up class="cs-order__number" :end="item" /> -->
						<span class="cs-order__number">{{item}}</span>
						<span class="cs-order__desc">{{key}}</span>
					</div>
				</div>
			</div>
		</div>
		<el-row :gutter="20">
			<el-col :span="14">
				<div class="cs-card">
					<i class="el-icon-collection-tag cs-pb">
						<span class="cs-pl-5">用户注册情况</span>
					</i>
					<div class="grid-content bg-purple">
						<div id="myChart_customerReg" style="width: auto;height:300px;"></div>
					</div>
				</div>
			</el-col>
			<el-col :span="10">
				<div class="cs-card">
					<i class="el-icon-collection-tag cs-pb">
						<span class="cs-pl-5">会员等级</span>
					</i>
					<div class="grid-content bg-purple">
						<div id="myChart_customer" style="width: auto;height:300px;"></div>
					</div>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="14">
				<div class="cs-card">
					<i class="el-icon-collection-tag cs-pb">
						<span class="cs-pl-5">用户下单情况</span>
					</i>
					<div class="grid-content bg-purple">
						<div id="myChart_customerOrder" style="width: auto;height:300px;"></div>
					</div>
				</div>
			</el-col>
			<el-col :span="10">
				<div class="cs-card">
					<i class="el-icon-collection-tag cs-pb">
						<span class="cs-pl-5">销售统计(只统计已付款)</span>
					</i>
					<table class="cs-sales">
						<tbody>
							<tr>
								<td rowspan="3" class="cs-sales__title">昨日实际销量</td>
							</tr>
							<tr>
								<td>
									<span>订单量</span>
									<span class="cs-sales__number">{{sales_statistics.yesterday.num_order}}</span>
								</td>
							</tr>
							<tr>
								<td>
									<span>销售额</span>
									<span class="cs-sales__number">{{sales_statistics.yesterday.num_order_money}}</span>
								</td>
							</tr>
							<tr style="height: 20px;"></tr>
							<tr>
								<td rowspan="3" class="cs-sales__title">本月实际销量</td>
							</tr>
							<tr>
								<td>
									<span>订单量</span>
									<span class="cs-sales__number">{{sales_statistics.current_month.num_order}}</span>
								</td>
							</tr>
							<tr>
								<td>
									<span>销售额</span>
									<span class="cs-sales__number">{{sales_statistics.current_month.num_order_money}}</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</el-col>

		</el-row>


	</div>
	
	
</template>

<script>
	import echarts from "echarts";
	export default {
		name: 'Home',
		inject: ['reload'],
		data() {
			return {
				// list: [],
				orderStatus: [], //订单状态
				customerReg: [], //用户注册情况
				customerOrder: [], //用户下单情况
				vip_grade: [], //会员等级
				sales_statistics:{
					yesterday: '',
					current_month: '',
				},  //销售统计
				rakuten_name:'',
			}
		},
		components: {
			echarts,
		},
		mounted() {
			this.getOrderStatus();
		},
		methods: {
			handleRefresh() {
				this.reload(); // 页面全部刷新 搭配	inject: ['reload'] 使用  不推荐
			},
			getOrderStatus() {
				this.httpPost({
					url: '/admin/home/home',
				}).then((res) => {
					this.orderStatus = res.data.order_status;
					this.customerReg = res.data.user;
					this.vip_grade = res.data.vip_grade;
					this.customerOrder = res.data.order;
					this.sales_statistics = res.data.sales_statistics;
					console.log(res)
					this.rakuten_name = res.data.admin_info.username;
					this.myChart_customerRegView();
					this.myChart_customerView();
					this.myChart_customerOrder();

				})
			},
			myChart_customerOrder() {
				// var i=0;
				// 基于准备好的dom，初始化echarts实例
				let myChart = echarts.init(document.getElementById("myChart_customerOrder"));

				// 指定图表的配置项和数据
				var option = {
					title: {
						// show:true,
						text: '最近两周客户订单情况',
						x: 'center',
					},
					//工具栏
					toolbox: {
						show: true,
						orient: 'horizontal',
						x: 'left',
						y: 'top',
						itemSize: 15,
						itemGap: 15,
						feature: {
							magicType: {
								type: ['line', 'bar']
							},
							mark: {
								show: true
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					grid: {
						top: '80',

					},
					// 提示框，鼠标移入
					tooltip: {
						show: true, //鼠标移入是否触发数据
						trigger: 'item', //触发方式
						formatter: '订单数:{c}'
					},
					xAxis: {
						type: 'category',
						axisLabel: {
							interval: 0,
							rotate: 270
						},
						name: '排名',
						nameTextStyle: {
							fontSize: 12,
							color: '#333333',
							fontWeight: 'bold'
						},
						data: this.customerReg.date, // x轴坐标名称
						// axisLabel: {  //坐标轴刻度标签的相关设置。
						//              formatter: '第{value}名'  //字符串模板
						//          }
					},
					yAxis: {
						type: 'value',
						name: '用户下单数', //名称
						nameTextStyle: {
							fontSize: 12,
							color: '#333333',
							fontWeight: 'bold'
						},
					},
					series: [{
						name: '客户数',
						type: 'bar',
						barWidth: '25%',
						data: this.customerOrder.num_order,
						emphasis: { // 高亮
							label: {
								show: true,
								textStyle: {
									color: '#333333',
									fontWeight: 'bold'
								}
							}
						},
						zoom: 1, //放大比例
						label: { //图形上的文本标签，可用于说明图形的一些数据信息
							// show: true,
						},
					}],


				};
				window.addEventListener('resize', () => {
					// 自动渲染echarts
					myChart.resize();
				})
				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);
			},
			myChart_customerRegView() {
				// var i=0;
				// 基于准备好的dom，初始化echarts实例
				let myChart = echarts.init(document.getElementById("myChart_customerReg"));

				// 指定图表的配置项和数据
				var option = {
					title: {
						// show:true,
						text: '最近两周客户注册情况',
						x: 'center',
					},
					//工具栏
					toolbox: {
						show: true,
						orient: 'horizontal',
						x: 'left',
						y: 'top',
						itemSize: 15,
						itemGap: 15,
						feature: {
							magicType: {
								type: ['line', 'bar']
							},
							mark: {
								show: true
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					grid: {
						top: '80',

					},
					// 提示框，鼠标移入
					tooltip: {
						show: true, //鼠标移入是否触发数据
						trigger: 'item', //触发方式
						formatter: '注册人数:{c}'
					},
					xAxis: {
						type: 'category',
						axisLabel: {
							interval: 0,
							rotate: 270
						},
						name: '排名',
						nameTextStyle: {
							fontSize: 12,
							color: '#333333',
							fontWeight: 'bold'
						},
						data: this.customerReg.date, // x轴坐标名称
						// axisLabel: {  //坐标轴刻度标签的相关设置。
						//              formatter: '第{value}名'  //字符串模板
						//          }
					},
					yAxis: {
						type: 'value',
						name: '用户注册人数', //名称
						nameTextStyle: {
							fontSize: 12,
							color: '#333333',
							fontWeight: 'bold'
						},
					},
					series: [{
						name: '客户数',
						type: 'bar',
						barWidth: '25%',
						data: this.customerReg.num,
						emphasis: { // 高亮
							label: {
								show: true,
								textStyle: {
									color: '#333333',
									fontWeight: 'bold'
								}
							}
						},
						zoom: 1, //放大比例
						label: { //图形上的文本标签，可用于说明图形的一些数据信息
							// show: true,
						},
					}],


				};
				window.addEventListener('resize', () => {
					// 自动渲染echarts
					myChart.resize();
				})
				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);
			},
			myChart_customerView() {
				let myChart = echarts.init(document.getElementById("myChart_customer"));

				var option = {
					tooltip: {
						trigger: 'item'
					},
					legend: {
						top: '8%',
						left: 'center'
					},
					//工具栏
					toolbox: {
						show: true,
						orient: 'horizontal',
						x: 'right',
						y: 'top',
						itemSize: 15,
						itemGap: 15,
						feature: {

							mark: {
								show: true
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					series: [{
						name: '会员等级',
						type: 'pie',
						radius: ['40%', '70%'],
						center: ['50%', '60%'],
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '20',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: this.vip_grade
					}]
				};
				window.addEventListener('resize', () => {
					// 自动渲染echarts
					myChart.resize();
				})
				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option);
			}
		},
		created() {
			// this.getOrderStatus()
		}
	}
</script>

<style>
	.cs-p {
		padding: 20px !important;
	}

	.cs-pb {
		padding-bottom: 20px !important;
	}

	.cs-p-5 {
		padding: 5px !important;
	}

	.cs-card-sub {
		font-size: 12px;
		color: #909399;
		cursor: pointer;
	}

	.cs-tc {
		text-align: center;
	}

	.cs-order .cs-order__number {
		font-size: 24px;
	}

	.cs-order span {
		display: block;
	}

	.cs-order .cs-order__desc {
		color: #909399;
	}

	.cs-card {
		color: #303133;
		border: 1px solid #dcdfe6;
		background: #FFF;
		font-size: 14px;
		position: relative;
		margin-bottom: 20px;
		padding: 20px;
	}

	[flex~="cross:center"] {
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
	}

	[flex~="main:center"] {
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
	}

	[flex] {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
	}

	[flex-box="1"] {
		-webkit-box-flex: 1;
		-ms-flex-positive: 1;
		flex-grow: 1;
		-ms-flex-negative: 1;
		flex-shrink: 1;
	}

	[flex]>* {
		display: block;
	}

	.cs-sales {
		color: #909399;
		border-collapse: collapse;
		border: none;
		width: 100%;
	}

	.cs-sales tr td {
		padding: 14px 0;
		border: 1px solid #dcdfe6;
	}

	.cs-sales span {
		padding-left: 10px;
	}

	.cs-sales .cs-sales__title {
		text-align: center;
		background: #F5F7FA;
		width: 30%;
	}

	.cs-sales .cs-sales__number {
		color: #303133;
		font-size: 18px;
	}
</style>
